var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deck-container",attrs:{"width":_vm.width,"height":_vm.height}},[_vm._t("background"),_vm._t("default"),_c('canvas',{ref:"canvas",attrs:{"id":"deck-canvas"},on:{"contextmenu":_vm.handleContextMenu}}),_vm._t("foreground")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }